import { buildProperty, buildSchema } from "@camberi/firecms";

export const warrantyDocumentSchema = buildSchema({
  name: "Warranty Documents",
  properties: {
    fileName: {
      title: "File Name",
      dataType: "string",
    },
    file: buildProperty({
      title: "File",
      dataType: "string",
      config: {
        storageMeta: {
          // TODO: pass a function to get a dynamic path based on the homeId
          storagePath: "warrantydocuments",
          acceptedFiles: ["application/*"],
        },
      },
    }),
  },
})